import styled, { css } from 'styled-components'
import { mobile, tablet } from '../../constants/breakpoints'

export const Page = styled.div`
  width: 100%;
  min-height: calc(100vh - 72px);
  margin: 72px auto 0 auto;
  background: #f8fcff;
  padding-top: 50px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: calc(${tablet})) {
    margin-top: -72px;
    padding-top: 72px;
  }
`

export const Spacer = styled.div<{ size: number }>`
  height: ${(props) => props.size}px;
  width: 100%;
`

export const LoadingWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 108px;
`

export const ContentWrap = styled.div`
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #b7bdc6;
  width: 100%;
  max-width: 742px;
  padding: 40px 60px;

  @media (max-width: calc(${tablet})) {
    border: none;
    padding: 20px 30px;
    background: #f8fcff;
  }

  h1 {
    width: 100%;
    text-align: center;
    color: #4c5197;
    font-family: Poppins;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 70px; /* 140% */
  }

  h2 {
    color: #4c5197;
    text-align: center;
    font-family: Poppins;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0 0 50px 0;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
`
export const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
`

export const FormWrap = styled.form`
  width: 100%;
  max-width: 820px;
  display: grid;
  gap: 0 20px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: calc(${mobile})) {
    grid-template-columns: 1fr;
  }

  input {
    height: 40px;
    width: 100%;
    border-radius: var(--Radius-s, 4px);
    border: var(--Radius-none, 1px) solid var(--Stroke-tertiary, #b7bdc6);
    background: var(--Background-primary, #fff);
    color: var(--Text-primary, #25292c);

    /* Paragraph 4 - Regular */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-4, 14px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Fonts-Line-height-Paragraph-4, 20px); /* 142.857% */

    padding-left: 16px;
    margin-top: 8px;
    margin-bottom: 30px;
  }

  label {
    width: 100%;
    display: block;
    color: var(--Text-header-primary, #2b253a);

    /* Paragraph 4 - Medium */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-4, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: var(--Fonts-Line-height-Paragraph-4, 20px); /* 142.857% */
  }

  button {
    display: flex;
    width: 200px;
    height: 40px;
    min-width: 120px;
    padding: 10px var(--Spacing-l, 24px);
    justify-content: center;
    align-items: center;
    gap: var(--Spacing-xs, 8px);
    border-radius: 6px;
    background: #fd5087;

    cursor: pointer;
    outline: none;
    border: none;
    color: var(--Button-Primary-text, #fff);
    text-align: center;

    margin: 0 0 0 auto;

    /* Paragraph 4 - Medium */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-4, 14px);
    font-style: normal;
    font-weight: 700;
    line-height: var(--Fonts-Line-height-Paragraph-4, 20px); /* 142.857% */

    transition: filter 0.2s, background 0.2s, color 0.2s;
    &:hover {
      filter: brightness(0.9);
    }

    &:disabled {
      background: #e6ddf9;
      color: #72839a;
      cursor: not-allowed;
    }
  }
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button,
  a {
    text-decoration: none;
    outline: none;
    border: none;
    display: flex;
    width: 250px;
    height: 48px;
    min-width: 136px;
    padding: 4px 0px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    background: #5e3cb4;
    color: var(--Button-Primary-text, #fff);
    text-align: center;

    /* Paragraph 3 - Medium */
    font-family: Inter;
    font-size: var(--Fonts-Size-Paragraph-3, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: var(--Fonts-Line-height-Paragraph-3, 24px); /* 150% */
    letter-spacing: -0.16px;

    transition: box-shadow 0.2s ease-out;

    &:hover {
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
      cursor: pointer;
    }

    &:disabled {
      filter: grayscale();
    }

    &:hover:disabled {
      cursor: default;
      box-shadow: none;
    }
  }
`
